import { EditDocumentFormDataProviderProps } from './edit-document-form-data-provider.types';
import { useCreateEditDocumentFormSchema } from '../edit-document-form/hooks/use-create-edit-document-form-schema';
import { EditDocumentFormContent } from '../edit-document-form-content/edit-document-form-content';

export const EditDocumentFormDataProvider = ({
  documentData,
}: EditDocumentFormDataProviderProps) => {
  const formSchema = useCreateEditDocumentFormSchema(documentData.formDataModel);
  const selectedDocumentModel = documentData.formDataModel?.actions?.edit ?? {
    items: [],
    rules: [],
  };

  return (
    <EditDocumentFormContent
      formSchema={formSchema}
      selectedDocumentModel={selectedDocumentModel}
      documentData={documentData}
      documentId={documentData.id}
    />
  );
};
